import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <main className="contact">

      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero__inner">
          <h1 className="contact-hero__title">Let's Connect</h1>
          <div className="spacer-small" />
          <div className="contact-hero__sub-wrap">
            <p className="contact-hero__sub">
              Have a project in mind or need expert marketing solutions? We're here to help!
              Reach out to us, and let's start crafting strategies that drive real results.
            </p>
          </div>
          <div className="spacer-small" />
          <div className="contact__socials">
            
             <a href="https://www.instagram.com/renartglobal"
              target="_blank"
              rel="noreferrer"
              className="contact__social-btn"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="white" stroke="none"/>
              </svg>
            </a>
            
              <a href="https://www.linkedin.com/company/renartglobal/"
              target="_blank"
              rel="noreferrer"
              className="contact__social-btn"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/>
                <rect x="2" y="9" width="4" height="12"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* FORM */}
      <section className="contact-form-section">
        <div className="contact-form-global">
          <div className="contact-form-container">
            <div className="contact-form-padding">
              <div className="contact-form-block">
                <div className="contact-form-wrapper">
                  {status === 'success' ? (
                    <div className="form-message-success">
                      Thank you! Your submission has been received!
                    </div>
                  ) : (
                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                      {status === 'error' && (
                        <div className="form-message-error">
                          Oops! Something went wrong while submitting the form.
                        </div>
                      )}

                      <input
                        className="form-input"
                        name="name"
                        type="text"
                        placeholder="Name"
                        value={form.name}
                        onChange={handleChange}
                        maxLength={256}
                      />
                      <div className="spacer-small" />
                      <input
                        className="form-input"
                        name="email"
                        type="email"
                        placeholder="Email Address"
                        value={form.email}
                        onChange={handleChange}
                        maxLength={256}
                        required
                      />
                      <div className="spacer-small" />
                      <input
                        className="form-input"
                        name="subject"
                        type="text"
                        placeholder="Subject"
                        value={form.subject}
                        onChange={handleChange}
                        maxLength={256}
                        required
                      />
                      <div className="spacer-small" />
                      <input
                        className="form-input form-input--textarea"
                        name="message"
                        type="text"
                        placeholder="Message"
                        value={form.message}
                        onChange={handleChange}
                        maxLength={256}
                        required
                      />
                      <div className="spacer-large" />
                      <button type="submit" className="form-submit-btn">
                        Send Message
                      </button>
                    </form>
                  )}
                </div>
              </div>
              <div className="spacer-xlarge" />
            </div>
            <div className="divider-line" />
          </div>
        </div>
      </section>

    </main>
  );
}